export const SESSION_STORAGE_AUTH = 'auth';
export const SESSION_STORAGE_STARTUP_CONFIG = 'startupConfig';
export const SESSION_STORAGE_APPLICATION_STATE = 'applicationState';
